import { type ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * A minimal modal dialog: a portaled backdrop + `dw-modal` box (the same shell
 * the embed editor uses) with a title, body, and a single dismiss button.
 * Click-outside or the button closes it. Used to surface publish outcomes that
 * shouldn't stick to the page (e.g. "published locally but not pushed").
 */
export function Dialog({
  title,
  onClose,
  children,
  tone = "info",
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  tone?: "info" | "warn" | "error";
}) {
  return createPortal(
    <div className="dw-modal-backdrop" onClick={onClose}>
      <div
        className={`dw-modal dw-dialog dw-dialog-${tone}`}
        role="alertdialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dw-modal-head">{title}</div>
        <div className="dw-dialog-body">{children}</div>
        <div className="dw-modal-foot">
          <button type="button" className="primary" autoFocus onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
